import "core-js/modules/es6.array.for-each";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
export default function addSignalListenersToView(view, signalListeners) {
  var signalNames = Object.keys(signalListeners);
  signalNames.forEach(function (signalName) {
    try {
      view.addSignalListener(signalName, signalListeners[signalName]);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('Cannot add invalid signal listener.', error);
    }
  });
  return signalNames.length > 0;
}